<template>
    <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 text-center">
            <img class="mx-auto border-2 border-gray rounded px-2 py-1 max-h-40 object-contain" v-if="signatureFile"
                 :src="isLocalUrl(signatureFile) ? signatureFile : baseUrl+'/auth/api/users/downloadFile/attachment/'+signatureFile"/>
            <p v-else class="bg-red-500 mx-auto rounded-sm p-3 text-white">
                User has no signature yet
            </p>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'

interface Props {
  userId?: string
  signatureFile?: string
}

const props = defineProps<Props>()

const baseUrl = ref<string>('')

onMounted(() => {
  baseUrl.value = import.meta.env.VITE_API_BASE_URL as string
})

const isLocalUrl = (url: string) => {
  return url.startsWith('data:') || url.startsWith('blob:')
}
</script>

